import { http } from '../../../../api/http';
import type { Utilidades, UtilidadesCalculoRequest } from '../types/utilidades';

const ENDPOINT = '/planilla/utilidades';

export class UtilidadesService {
  static async calcular(request: UtilidadesCalculoRequest): Promise<Utilidades> {
    const response = await http.post(`${ENDPOINT}/calcular`, request);
    return response.data;
  }

  static async grabar(request: UtilidadesCalculoRequest): Promise<Utilidades> {
    const response = await http.post(`${ENDPOINT}/grabar`, request);
    return response.data;
  }

  static async getAll(): Promise<Utilidades[]> {
    const response = await http.get(ENDPOINT);
    return response.data;
  }

  static async getById(id: number): Promise<Utilidades> {
    const response = await http.get(`${ENDPOINT}/${id}`);
    return response.data;
  }

  static async cambiarEstado(id: number, nuevoEstado: string): Promise<Utilidades> {
    const response = await http.put(`${ENDPOINT}/${id}/estado`, { nuevoEstado });
    return response.data;
  }
}
